/* ============================================================
   HERO BANNER V3 (hb3)
   - Binds Alia open action to the "First Time Customer" button
   - Adds scheduled visibility: hide at a set time, optionally show again
   - Safe for Theme Editor re-renders (section load/select)
   ============================================================ */

(function () {
  function parseHb3ScheduleDate(value) {
    var cleanValue = value ? value.trim() : "";

    if (!cleanValue) {
      return null;
    }

    var shopifyDateMatch = cleanValue.match(/^(\d{4}-\d{2}-\d{2})\s+(\d{2}:\d{2}(?::\d{2})?)\s+([+-]\d{2})(\d{2})$/);

    if (shopifyDateMatch) {
      cleanValue = shopifyDateMatch[1] + "T" + shopifyDateMatch[2] + shopifyDateMatch[3] + ":" + shopifyDateMatch[4];
    }

    var parsedDate = new Date(cleanValue);

    if (isNaN(parsedDate.getTime())) {
      return null;
    }

    return parsedDate;
  }

  function getHb3Wrapper(root) {
    if (!root) return null;

    var sectionId = root.getAttribute("data-section-id");

    if (!sectionId) {
      return root.closest(".shopify-section");
    }

    return document.getElementById("shopify-section-" + sectionId) || root.closest(".shopify-section");
  }

  function hideHb3(root) {
    if (!root) return;

    var wrapper = getHb3Wrapper(root);

    root.classList.add("hb3-schedule-hidden");
    root.setAttribute("hidden", "");
    root.setAttribute("aria-hidden", "true");

    if (wrapper) {
      wrapper.classList.add("hb3-schedule-hidden-wrapper");
    }
  }

  function showHb3(root) {
    if (!root) return;

    var wrapper = getHb3Wrapper(root);

    root.classList.remove("hb3-schedule-hidden");
    root.removeAttribute("hidden");
    root.removeAttribute("aria-hidden");

    if (wrapper) {
      wrapper.classList.remove("hb3-schedule-hidden-wrapper");
    }
  }

  function clearHb3ScheduleTimers(root) {
    if (!root) return;

    if (root._hb3HideTimer) {
      window.clearTimeout(root._hb3HideTimer);
      root._hb3HideTimer = null;
    }

    if (root._hb3ShowTimer) {
      window.clearTimeout(root._hb3ShowTimer);
      root._hb3ShowTimer = null;
    }
  }

  function setHb3SafeTimeout(callback, delay) {
    var maxDelay = 2147483647;
    return window.setTimeout(callback, Math.min(delay, maxDelay));
  }

  function applyHb3Schedule(root) {
    if (!root) return;

    clearHb3ScheduleTimers(root);

    var scheduleEnabled = root.getAttribute("data-schedule-enabled") === "true";
    var hideStartValue = root.getAttribute("data-hide-start-datetime");
    var showAgainValue = root.getAttribute("data-show-again-datetime");

    if (!scheduleEnabled) {
      showHb3(root);
      return;
    }

    var hideStartDate = parseHb3ScheduleDate(hideStartValue);
    var showAgainDate = parseHb3ScheduleDate(showAgainValue);

    if (!hideStartDate) {
      showHb3(root);
      return;
    }

    var nowTimestamp = new Date().getTime();
    var hideStartTimestamp = hideStartDate.getTime();
    var showAgainTimestamp = showAgainDate ? showAgainDate.getTime() : null;

    if (showAgainTimestamp && showAgainTimestamp <= hideStartTimestamp) {
      showAgainTimestamp = null;
    }

    if (nowTimestamp >= hideStartTimestamp && (!showAgainTimestamp || nowTimestamp < showAgainTimestamp)) {
      hideHb3(root);
    } else {
      showHb3(root);
    }

    if (nowTimestamp < hideStartTimestamp) {
      root._hb3HideTimer = setHb3SafeTimeout(function () {
        applyHb3Schedule(root);
      }, hideStartTimestamp - nowTimestamp);
    }

    if (showAgainTimestamp && nowTimestamp < showAgainTimestamp) {
      root._hb3ShowTimer = setHb3SafeTimeout(function () {
        applyHb3Schedule(root);
      }, showAgainTimestamp - nowTimestamp);
    }
  }

  function bindHb3(root) {
    if (!root) return;

    applyHb3Schedule(root);

    // Only bind if the section is configured to use Alia
    var aliaEnabled = root.getAttribute("data-alia-enabled");
    if (aliaEnabled !== "true") return;

    var campaignId = parseInt(root.getAttribute("data-alia-campaign-id") || "", 10);
    if (!campaignId) return;

    var btn = root.querySelector(".hb3-firstTimeCustomer");
    if (!btn) return;

    // Prevent double-binding
    if (btn._hb3AliaBound) {
      btn.removeEventListener("click", btn._hb3AliaBound);
    }

    function handler(e) {
      e.preventDefault();
      e.stopPropagation();

      window.alia = window.alia || [];
      window.alia.push({
        type: "open",
        campaignID: campaignId,
        ignoreTargeting: true
      });
    }

    btn.addEventListener("click", handler);
    btn._hb3AliaBound = handler;
  }

  function initAll() {
    document.querySelectorAll(".hb3-sec[data-hb3]").forEach(function (root) {
      bindHb3(root);
    });
  }

  document.addEventListener("DOMContentLoaded", initAll);

  // Theme Editor dynamic loads
  document.addEventListener("shopify:section:load", function (e) {
    if (!e.detail || !e.detail.sectionId) return;
    var root = document.querySelector('.hb3-sec[data-hb3][data-section-id="' + e.detail.sectionId + '"]');
    bindHb3(root);
  });

  document.addEventListener("shopify:section:select", function (e) {
    if (!e.detail || !e.detail.sectionId) return;
    var root = document.querySelector('.hb3-sec[data-hb3][data-section-id="' + e.detail.sectionId + '"]');
    bindHb3(root);
  });
})();